<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				其他险种出险-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:540px;background-color:white;margin:75px 40px 0 40px;padding:100px;overflow-x: hidden">
				<!-- 查询框 -->
				<span style="color:#006E4B;font-weight:900;font-size:20px">| </span>
				<span style="font-size:20px;font-weight:700">基本信息</span>
				<div style="border:1px solid #DADADA;margin-top:10px"></div>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<el-form-item label="保单名称" prop="insurance_id" style="margin-top:50px">
								<el-select v-model="ruleForm.insurance_id" style="width:74%" placeholder="请选择保单名称"
									@change="sbm" clearable>
									<el-option v-for="item in bdList" :key="item.id" :label="item.insurance_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="保单号" prop="policy" style="margin-top:50px;width:80%">
								<el-input v-model="ruleForm.policy_no" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="唯一识别码" prop="detailed_id">
								<el-select v-model="ruleForm.detailed_id" style="width:74%" filterable
									:placeholder="project_placeholder" clearable @change="ChangeDetailed">
									<el-option v-for="item in sbmtList" :key="item.id" :label="item.unique_id"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="名称/品牌" prop="brand" style="width:80%">
								<el-input v-model="ruleForm.brand" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="型号/规格" prop="model" style="width:80%">
								<el-input v-model="ruleForm.model" :disabled="true"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">

						</el-col>
					</el-row>

					<div style="margin-top:50px">
						<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
						<span style="font-size:20px;font-weight:700">出险信息</span>
						<div style="border:1px solid #DADADA;margin-top:10px"></div>

						<el-row>
							<el-col :span="12">
								<el-form-item label="出险时间" prop="danger_time" style="margin-top:50px">
									<el-date-picker v-model="ruleForm.danger_time" type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" style="width:73%" placeholder="请选择出险时间">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">

							</el-col>
						</el-row>

						<el-row>
							<el-col>
								<el-form-item label="出险经过" prop="danger_after" style="width:90%">
									<el-input type="textarea" :rows="2" v-model="ruleForm.danger_after"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col>
								<el-form-item label="事故照片" prop="accident_photo">
									<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
										:on-preview="sghandlePictureCardPreview" :limit="4" :on-remove="handleRemove"
										:file-list="ruleForm.accident_photo" :on-success="sghandleAvatarSuccess">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-dialog :visible.sync="dialogVisible">
										<img width="100%" :src="ruleForm.accident_photo" alt="">
									</el-dialog>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="报案号" prop="report_no" style="width:80%">
									<el-input v-model="ruleForm.report_no" placeholder="请输入报案号"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="保单号" prop="policy_no" style="width:80%">
									<el-input v-model="ruleForm.policy_no" placeholder="请输入保单号"></el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="理赔情况" prop="settlement_status">
									<el-select v-model="ruleForm.settlement_status" placeholder="请选择理赔情况"
										style="width:73%" @change="saveRules" clearable>
										<el-option v-for="item in ztList" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="医疗票据" prop="bill_url" style="width:80%">
									<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
										:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
										:file-list="ruleForm.bill_url" :on-success="handleAvatarSuccess">
										<i class="el-icon-plus"></i>
									</el-upload>
									<el-dialog :visible.sync="dialogVisible">
										<img width="100%" :src="ruleForm.bill_url" alt="">
									</el-dialog>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="收保险公司理赔款" prop="settlement_amount" style="width:80%">
									<el-input type="number" v-model="ruleForm.settlement_amount"
										placeholder="请输入收保险公司理赔款"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="付员工理赔款" prop="indemnity_amount" style="width:80%">
									<el-input type="number" v-model="ruleForm.indemnity_amount" placeholder="请输入付员工理赔款">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="12">
								<el-form-item label="结案日期" prop="close_date">
									<el-date-picker v-model="ruleForm.close_date" type="date" style="width:73%"
										value-format="yyyy-MM-dd" placeholder="请选择结案日期"></el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="情况备注" prop="remarks" style="width:80%">
									<el-input v-model="ruleForm.remarks" placeholder="请填写备注"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</div>



					<el-form-item style="margin-left:400px;margin-top:50px">
						<el-button type="goon" v-show="ruleForm.id === null || ruleForm.id === ''"
							@click="submitForm('ruleForm')">保存</el-button>
						<el-button type="goon" @click="Update('ruleForm')"
							v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bdList: [],
				sbmtList: [],
				//状态下拉
				ztList: [{
					value: '0',
					label: '未理赔'
				}, {
					value: '1',
					label: '已理赔'
				}, {
					value: '2',
					label: '已撤案'
				}],
				ruleForm: {
					insurance_id: '',
					detailed_id: '',
					unique_id: '',
					insurance_name: '',
					policy_no: '',
					brand: '',
					model: '',
					danger_time: '',
					danger_after: '',
					report_no: '',
					policy_no: '',
					settlement_status: '',
					settlement_amount: '',
					indemnity_amount: '',
					close_date: '',
					remarks: '',
					bill_url: [],
					accident_photo: [],
				},
				rules: {
				  insurance_id:[
				    { required: true, message: '请选择保单名称', trigger: 'blur' },
				  ],
				  detailed_id: [
				    { required: true, message: '请选择唯一识别码', trigger: 'blur' },
				  ],
				  danger_time: [
				    { required: true, message: '请输入出险时间', trigger: 'blur' },
				  ],
				  danger_after: [
				    { required: true, message: '请输入出险经过', trigger: 'blur' },
				  ],
				  // accident_photo: [
				  //   { required: true, message: '请上传事故照片', trigger: 'change' },
				  // ],
				  report_no: [
				    { required: true, message: '请输入报案号', trigger: 'blur' },
				  ],
				  policy_no: [
				    { required: true, message: '请输入保单号', trigger: 'blur' },
				  ],
				  settlement_status: [
				    { required: true, message: '请选择理赔情况', trigger: 'blur' },
				  ],
				  // bill_url: [
				  //   { required: true, message: '请上传医疗票据', trigger: 'change' },
				  // ],
				  // settlement_amount: [
				  //   { required: true, message: '请输入收保险公司理赔款', trigger: 'blur' },
				  // ],
				  // indemnity_amount: [
				  //   { required: true, message: '请输入付员工理赔款', trigger: 'blur' },
				  // ],
				  // close_date: [
				  //   { required: true, message: '请输入结案日期', trigger: 'blur' },
				  // ],
				}
			};
		},
		methods: {
			saveRules() {
				if (this.ruleForm.settlement_status == '0' || this.ruleForm.settlement_status == '2') {
					this.rules = {};
					this.rules = {
						insurance_id: [{
							required: true,
							message: '请选择保单名称',
							trigger: 'blur'
						}, ],
						detailed_id: [{
							required: true,
							message: '请选择唯一识别码',
							trigger: 'blur'
						}, ],
						danger_time: [{
							required: true,
							message: '请输入出险时间',
							trigger: 'blur'
						}, ],
						danger_after: [{
							required: true,
							message: '请输入出险经过',
							trigger: 'blur'
						}, ],
						// accident_photo: [
						//   { required: true, message: '请上传事故照片', trigger: 'change' },
						// ],
						report_no: [{
							required: true,
							message: '请输入报案号',
							trigger: 'blur'
						}, ],
						policy_no: [{
							required: true,
							message: '请输入保单号',
							trigger: 'blur'
						}, ],
						settlement_status: [{
							required: true,
							message: '请选择理赔情况',
							trigger: 'blur'
						}, ],
					}
				} else {
					this.rules = {};
					this.rules = {
						insurance_id: [{
							required: true,
							message: '请选择保单名称',
							trigger: 'blur'
						}, ],
						detailed_id: [{
							required: true,
							message: '请选择唯一识别码',
							trigger: 'blur'
						}, ],
						danger_time: [{
							required: true,
							message: '请输入出险时间',
							trigger: 'blur'
						}, ],
						danger_after: [{
							required: true,
							message: '请输入出险经过',
							trigger: 'blur'
						}, ],
						// accident_photo: [
						//   { required: true, message: '请上传事故照片', trigger: 'change' },
						// ],
						report_no: [{
							required: true,
							message: '请输入报案号',
							trigger: 'blur'
						}, ],
						policy_no: [{
							required: true,
							message: '请输入保单号',
							trigger: 'blur'
						}, ],
						settlement_status: [{
							required: true,
							message: '请选择理赔情况',
							trigger: 'blur'
						}, ],
						// bill_url: [
						//   { required: true, message: '请上传医疗票据', trigger: 'change' },
						// ],
						settlement_amount: [{
							required: true,
							message: '请输入收保险公司理赔款',
							trigger: 'blur'
						}, ],
						indemnity_amount: [{
							required: true,
							message: '请输入付员工理赔款',
							trigger: 'blur'
						}, ],
						close_date: [{
							required: true,
							message: '请输入结案日期',
							trigger: 'blur'
						}, ],
						settlement_amount: [{
							required: true,
							message: '请输入收保险公司理赔款',
							trigger: 'blur'
						}, ],
						indemnity_amount: [{
							required: true,
							message: '请输入付员工理赔款',
							trigger: 'blur'
						}, ],
						close_date: [{
							required: true,
							message: '请输入结案日期',
							trigger: 'blur'
						}, ],
					}

				}
			},
			ChangeDetailed(e) {
				this.sbmtList.forEach(item => {
					if (item.id == e) {
						this.ruleForm.brand = item.brand;
						this.ruleForm.model = item.model;
					}
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var accident_photo = "";
						this.ruleForm.accident_photo.forEach(item => {
							accident_photo += ";" + item;
						})

						var bill_url = this.ruleForm.bill_url.length > 0 ? this.ruleForm.bill_url[0] : '';

						var url = 'InsuranceDanger/insert';
						var record = {
							insurance_id: this.ruleForm.insurance_id,
							detailed_id: this.ruleForm.detailed_id,
							policy_no: this.ruleForm.policy_no,
							brand: this.ruleForm.brand,
							model: this.ruleForm.model,
							danger_time: this.ruleForm.danger_time,
							danger_after: this.ruleForm.danger_after,
							report_no: this.ruleForm.report_no,
							policy_no: this.ruleForm.policy_no,
							settlement_status: this.ruleForm.settlement_status,
							settlement_amount: this.ruleForm.settlement_amount,
							indemnity_amount: this.ruleForm.indemnity_amount,
							close_date: this.ruleForm.close_date,
							remarks: this.ruleForm.remarks,
							bill_url: bill_url,
							accident_photo: accident_photo,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 修改
			Update(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var accident_photo = "";
						this.ruleForm.accident_photo.forEach(item => {
							accident_photo += ";" + item;
						})
						var bill_url = this.ruleForm.bill_url.length > 0 ? this.ruleForm.bill_url[0].url : '';

						var url = '/InsuranceDanger/update';
						var record = {
							id: this.ruleForm.id,
							insurance_id: this.ruleForm.insurance_id,
							detailed_id: this.ruleForm.detailed_id,
							unique_id: this.ruleForm.unique_id,
							insurance_name: this.ruleForm.insurance_name,
							policy_no: this.ruleForm.policy_no,
							brand: this.ruleForm.brand,
							model: this.ruleForm.model,
							danger_time: this.ruleForm.danger_time,
							danger_after: this.ruleForm.danger_after,
							report_no: this.ruleForm.report_no,
							policy_no: this.ruleForm.policy_no,
							settlement_status: this.ruleForm.settlement_status,
							settlement_amount: this.ruleForm.settlement_amount,
							indemnity_amount: this.ruleForm.indemnity_amount,
							close_date: this.ruleForm.close_date,
							remarks: this.ruleForm.remarks,
							bill_url: bill_url,
							accident_photo: accident_photo,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.bill_url.push(res.data.fileUrl);
				debugger
			},
			sghandleAvatarSuccess(res, file) {
				this.ruleForm.accident_photo.push(res.data.fileUrl)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			sghandlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			//选择识别码
			async sbm(e) {
				if (e != undefined && e != null && e != '') {
					this.project_placeholder = "请先选择保单名称";
					this.sbmtList = [];
				} else {
					this.ruleForm.detailed_id = "";
					this.project_placeholder = "请先选择保单名称";
					this.sbmtList = [];
				}
				if (this.ruleForm.insurance_id != null && this.ruleForm.insurance_id != '') {

					var sbmList = await this.$globals.AxiosPost("InsuranceDetailed/selectKey", {
						insurance_id: this.ruleForm.insurance_id
					});
					this.project_placeholder = "请选择";
					this.sbmtList = sbmList.data;
				}
				this.$forceUpdate();
				this.bdList.forEach(item => {
					if (item.id == e) {
						this.ruleForm.policy_no = item.policy_no;
					}
				});
				this.insurance_id.forEach(item => {
					if (item.id === this.ruleForm.insurance_id) {
						this.ruleForm.policy_no = item.policy_no;
					}
				})
			},
			Return() {
				this.$parent.Return();
			},
		},
		async created() {
			// 保单
			var bdList = await this.$globals.AxiosPost("OtherInsurance/SelectKey", {});
			this.bdList = bdList.data;
			this.ruleForm = this.$parent.ruleForm;
		},
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Qtxzcx_add.vue?28c528b0